import React, { useEffect, useRef, useState } from "react";
import { Box, Chip, Divider, Tooltip, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { StyledButton } from "../../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../../shared/components/stepper/steppers";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../../shared/components/buttons/floating-button-container";
import FacilityInfoForm from "./facility-information";
import FacilityProcessInfo from "./facility-details";
import {
  FacilityFarmCapacityInformation,
  mapFacilityDetails,
  mapToFacilityDetailsDeteleSaveReq,
  mapToFacilityDetailsReq,
} from "../../../sc-models/facility-product-dto";
// import { SCAppConfig } from '../../../../../shared/app-configs/sc-app-config';
import { useApi } from "../../../../../../shared/hooks/useApi";
import useNotification from "../../../../../../shared/hooks/useNotification";
import { API_ROUTES } from "../../../../../../shared/app-configs/sc-app-config";
import { LoaderComponent } from "../../../../../../shared/components/loaders/page-loader";
import _ from "lodash";
import { useFormActions } from "../../../../../../shared/hooks/form-builder.hooks";
import AlertPopup from "../../../../../../shared/components/modals/alert-moadal";
import { Utills } from "../../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import {
  convertFacilityData,
  fetchFacilityDetails,
} from "./facility-setail-api";
import { useTransactionCertificateStore } from "../../../../../../store/transaction-certificates.store";
import { useScStore } from "../../../../../../store/scStandard.store";
import { useSCDataPrefetch } from "../../hooks/useSCDataPrefetch";
import { scCacheService } from "../../utils/scCacheService";
import { FarmCategoryUtils } from "../../../constants/farm-categories";
import FacilityFarmCapacityInfo from "./facility-farm-capacity";

interface FacilityInformation {
  facilityId?: string;
  isMainSite: string;
  facilityNo?: string;
  facilityType: string;
  facilityOsId:string;
  facilityProductionCapacity?: number;
  facilityAdditionalScopes:string;
  facilityTeId?: string;
  facilityStandard?: string[];
  facilityName: string;
  facilityAddress1: string;
  facilityAddress2?: string;
  facilityAddress3?: string;
  facilityAddedDate:string;
  facilityRemovedDate?:string;
  facilityLastAuditDate?:string;
  facilityPostcode: string;
  facilityTown: string;
  facilityCountryOrArea: string;
  facilityStateOrProvince: string;
  facilityCbOfIndependentlyCertifiedSubcontractor: string;
}
export interface FacilityProcessDetails {
  facilityProcessCategoryCode: string;
  facilityProcessCategoryCodeDescription: string;
  facilityProcessCategoryUserSpecificTerm:string;
}
interface FacilityState {
  facilityInfo: FacilityInformation;
  facilityProcessInformation: FacilityProcessDetails[];
  facilityFarmCapacityInformation:FacilityFarmCapacityInformation[];
}

const initFacilityInfo: FacilityInformation = {
  isMainSite: "Y",
  // facilityNo: "",
  facilityType: "",
  facilityAdditionalScopes: "",
  facilityOsId: "",
  facilityAddedDate: "",
  facilityLastAuditDate: "",
  facilityRemovedDate: "",
  facilityProductionCapacity: undefined,
  facilityTeId: "",
  // brandNames: '',
  facilityStandard: [],
  facilityName: "",
  facilityAddress1: "",
  facilityAddress2: "",
  facilityAddress3: "",
  facilityPostcode: "",
  facilityTown: "",
  facilityCountryOrArea: "",
  facilityStateOrProvince: "",
  facilityCbOfIndependentlyCertifiedSubcontractor: "",
};

const initFacilityState: FacilityState = {
  facilityInfo: initFacilityInfo,
  facilityProcessInformation:  [],
  facilityFarmCapacityInformation:[]
};

interface ScopeCertifiedDetailsComponentProps {
  onNextTab: () => Promise<void>;
  scStatus?: boolean;
  /** Called whenever the facility list changes so the parent can enable/disable downstream tabs */
  onFacilitiesChange?: (hasAny: boolean) => void;
}

const ScopeCertifiedDetailsComponent: React.FC<
  ScopeCertifiedDetailsComponentProps
> = ({ onNextTab, scStatus, onFacilitiesChange }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const [data, setData] = useState<FacilityState[]>([]);
  const [apiData, setAPIData] = useState<FacilityState[]>([]);
  const [mainFacility, setMainFacility] = useState<FacilityState | undefined>();
  const [tableData, setTableData] = useState<any[]>([]);
  const [facilityData, setFacilityData] =
    useState<FacilityState>(initFacilityState);
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [isDeleteOnly, setDeleteOnly] = useState(false);
  const { isRestrictPopUpSave } = useTransactionCertificateStore();
    const [isFarmSite,setIsFarmSite] = useState<boolean>(false);
  
  const navigate = useNavigate();
  const {
    apiData: shipmentData,
    loading,
    error,
    executeGet,
    setLoadingState,
    executePost,
    executeDelete,
  } = useApi();
  const { executeGet: executeNewGet, loading: loadingNewGet } = useApi();
  const { notify } = useNotification();
  const [getEditExistingFacilityDetails, setEditExistingFacilityDetails] =
    useState({
      index: -1,
      value: "",
    });
  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    updateTableRowbyIndex,
    removeTableRowbyIndex,
    replaceTableDatas,
    updateField,
    setDeleteSave,
    setEditSave,
    resetFormValueByPage,
    getDeleteSave,
  } = useFormActions("sc-facilitydetails");
  const facilityInfoRef = useRef<any>(null);
  const facilityFarmCapacityInfoRef = useRef<any>(null);
  const rawMaterialRef = useRef<any>(null);
  const { formtype, SC_ID } = useParams();
  const hasCreateSC = formtype === "create-sc";
  const hasSubmitSC: boolean = formtype === "submited-sc";
  const isReadOnlyBasedOnStatus = hasSubmitSC || scStatus;
  const { scStandards, setScStandards, setScStandardDescriptions, setCachedFacilityDetail, invalidateFacilityDetail, clearFacilityCache, clearFacilityListCache, clearScData, setTabError, reviewedFacilities, incrementFacilityCacheTick, scDetailsSaveTick } = useScStore();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const [facilityId, setFacilityId] = useState<string>("");
  // const [facilityNo, setFacilityNo] = useState<string>("");
  const [facilityTeId, setFacilityTeId] = useState<string>("");
  const [pendingSave, setPendingSave] = useState<any>(null);
  const [subsequentFacilityFlag, setSubsequentFacilityFlag] =
    useState<boolean>(false);
  const [scSubsequentFacilityButtonFlag, setScSubsequentFacilityButtonFlag] =
    useState<boolean>(true);
  const [scNoOfFarmsFlag, setScNoOfFarmsFlag] = useState<boolean>(false);
  /** Incremented each time the facility form should remount with fresh data (new or edit). */
  const [formKey, setFormKey] = useState<number>(0);
  
  // Helper function to check if any process category is a farm category
  const checkAndUpdateIsFarmSite = (processData: FacilityProcessDetails[]) => {
    const hasFarmCategory = processData.some((process) =>
      FarmCategoryUtils.isFarmCode(process?.facilityProcessCategoryCode)
    );
    setIsFarmSite(hasFarmCategory);
    return hasFarmCategory;
  };
  
  const setZustandInitialState = (initialState?: any) => {
    //set zustand state inital values
    const defaultState = initialState ?? initFacilityState;
    Object.entries(defaultState?.facilityInfo).forEach(([key, value]) => {
      updateField(key, value);
    });
    updateField("facilityProcessDetails", defaultState.facilityProcessDetails);
  };
  const loadFormData = async (forceRefresh = false) => {
    try {
      let isFarmSC = false;
      if (SC_ID) {
        try {
          // Use cached scData from Zustand store if SC Details tab already fetched it.
          // Only call GET_SC_DETAILS_V4 if the store is empty (e.g., direct navigation to this tab).
          let rawScData = useScStore.getState().scData;
          if (!rawScData || forceRefresh) {
            const scResponse = await executeGet(API_ROUTES.GET_SC_DETAILS_V4, { scId: SC_ID });
            rawScData = scResponse?.data;
            if (rawScData) {
              useScStore.getState().setScData(rawScData);
            }
          }
          const standards = rawScData?.scStandardInformation?.map(
            (item: any) => item.scStandard
          ) || [];
          setScStandards(standards);
          const descMap: Record<string, string> = {};
          (rawScData?.scStandardInformation || []).forEach((item: any) => {
            if (item.scStandard && item.scStandardDescription) {
              descMap[item.scStandard] = item.scStandardDescription;
            }
          });
          setScStandardDescriptions(descMap);
          const rawIsFarmSC = rawScData?.isFarmSC;
          console.log("[loadFormData] isFarmSC raw value:", rawIsFarmSC);
          isFarmSC = rawIsFarmSC === 'Y';
          setScNoOfFarmsFlag(isFarmSC);
        } catch (err) {
          console.error("Failed to fetch SC Details for standards:", err);
        }
      }

      // On forceRefresh (initial page load / after save) always bypass L1 list cache
      // to prevent stale empty data from masking process codes and standards.
      let listResponseData = forceRefresh ? null : useScStore.getState().facilityListCache;
      if (!listResponseData) {
        const response: any = await executeGet(API_ROUTES.GET_FACILITY_LIST_DETAILS_V4, { scId: SC_ID });
        listResponseData = response?.data?.response;
        if (listResponseData) {
          useScStore.getState().setFacilityListCache(listResponseData);
        }
      }
      let result = mapFacilityDetails(listResponseData || []);

      // Always enrich for existing SCs so that facilityProcessInformation and facilityStandard
      // are populated before the violation warning check runs. The list API does not return them.
      // When forceRefresh=true (page load / after save): skip L1 cache entirely, call detail API
      // fresh for every facility and update cache. This ensures the violation check always has
      // the latest saved data, not a stale snapshot.
      if (SC_ID && result.length > 0) {
        try {
          const detailedPromises = result.map(async (facility: any) => {
            try {
              const fid = facility.facilityInfo.facilityId;

              let fullFacilityData: any = null;

              if (!forceRefresh) {
                // Return visit: serve from L1 Zustand cache to avoid redundant API calls
                const { facilityDetailsCache } = useScStore.getState();
                fullFacilityData = facilityDetailsCache[fid] || null;
              }

              if (!fullFacilityData) {
                // forceRefresh OR cache miss: fetch fresh from API and update L1 cache
                const detailResp = await executeNewGet(API_ROUTES.GET_FACILITY_DETAILS_V4, { scId: SC_ID, facilityId: fid });
                fullFacilityData = detailResp?.data;
                if (fullFacilityData) {
                  setCachedFacilityDetail(fid, fullFacilityData);
                }
              }

              if (fullFacilityData) {
                facility.facilityProcessInformation = (fullFacilityData.facilityProcessInformation || []).map((p: any) => ({
                  facilityProcessCategoryCode: p.facilityProcessCategoryCode,
                  facilityProcessCategoryCodeDescription: p.facilityProcessCategoryCodeDescription,
                  facilityProcessCategoryUserSpecificTerm: p.facilityProcessCategoryUserSpecificTerm,
                }));
                facility.facilityInfo.facilityStandard = fullFacilityData.facilityStandard || [];
              }
            } catch(err) {
              console.error("Failed to load details for", facility.facilityInfo.facilityId);
            }
            return facility;
          });
          result = await Promise.all(detailedPromises);
        } catch (err) {
          console.error("Failed to enrich facility list with process details", err);
        }
      }

      setTableData(result);
      setAPIData(result);
      setMainFacility(
        result?.find(
          (facility) => facility?.facilityInfo?.facilityType === "MF"
        )
      );
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  useEffect(() => {
    if (SC_ID || !hasCreateSC) {
      // forceRefresh=true: bypass L1 cache on initial mount so violation check always
      // has complete standards + process codes from the API, not stale cached data.
      loadFormData(true);
    } else {
      updateTableData([]);
    }
  }, [SC_ID]);

  // refreshFacilityDetails: called after SC Details saves (scDetailsSaveTick increments).
  // SC Details already called GET_FACILITY_DETAILS_V4 for each facility and seeded
  // the L1 Zustand cache. This function reads the fresh cache and rebuilds tableData
  // so the violation check immediately sees the latest standards and process codes.
  const refreshFacilityDetails = async () => {
    if (!SC_ID) return;
    try {
      // Step 1: Re-fetch SC details to get the newly saved standards into Zustand
      const scResp = await executeGet(API_ROUTES.GET_SC_DETAILS_V4, { scId: SC_ID });
      const rawScData = scResp?.data;
      if (rawScData) {
        useScStore.getState().setScData(rawScData);
        const standards = rawScData?.scStandardInformation?.map((item: any) => item.scStandard) || [];
        setScStandards(standards);
      }

      // Step 2: If no facilities are loaded yet, run full load
      if (!tableData || tableData.length === 0) {
        loadFormData(true);
        return;
      }

      // Step 3: Rebuild tableData from the Zustand L1 cache seeded by SC Details save
      const { facilityDetailsCache } = useScStore.getState();
      const refreshed = tableData.map((facility: any) => {
        const fid = facility?.facilityInfo?.facilityId;
        if (!fid) return facility;
        const cached = facilityDetailsCache[fid];
        if (!cached) return facility;
        return {
          ...facility,
          facilityProcessInformation: (cached.facilityProcessInformation || []).map((p: any) => ({
            facilityProcessCategoryCode: p.facilityProcessCategoryCode,
            facilityProcessCategoryCodeDescription: p.facilityProcessCategoryCodeDescription,
            facilityProcessCategoryUserSpecificTerm: p.facilityProcessCategoryUserSpecificTerm,
          })),
          facilityInfo: {
            ...facility.facilityInfo,
            facilityStandard: cached.facilityStandard || [],
          },
        };
      });

      // Step 4: Update tableData — triggers re-render and violation check
      setTableData(refreshed);
      setAPIData(refreshed);
      console.log('[refreshFacilityDetails] tableData rebuilt from L1 cache with latest facility details and standards');
    } catch (err) {
      console.error('[refreshFacilityDetails] Error refreshing facility details', err);
    }
  };



  const prevScDetailsSaveTickRef = React.useRef<number>(scDetailsSaveTick);
  useEffect(() => {
    if (scDetailsSaveTick !== prevScDetailsSaveTickRef.current) {
      prevScDetailsSaveTickRef.current = scDetailsSaveTick;
      if (SC_ID) {
        // SC Details saved — re-fetch individual facility detail APIs and update
        // the violation check with the latest standards and process codes.
        refreshFacilityDetails();
      }
    }
  }, [scDetailsSaveTick]);

  // Notify parent whenever the facility list grows or shrinks (including deletion to empty).
  // Parent uses this to disable/warn downstream tabs when no facilities exist.
  useEffect(() => {
    onFacilitiesChange?.(tableData.length > 0);
  }, [tableData]);

  const toggleDrawer = () => {
    if (drawerOpen) {
      resetForm();
      setFacilityData(initFacilityState);
      setZustandInitialState();
      setIsFarmSite(false);
      setFacilityId("");
      // setFacilityNo("");
      setEditingIndex(-1);
    } else {
      // Reset isFarmSite when opening drawer for new facility
      setIsFarmSite(false);
    }
    setActiveStep(0);
    setDrawerOpen((prev) => !prev);
  };

  const handleDataUpdate = (stepKey: keyof FacilityState, updatedData: any) => {
    setFacilityData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
    
    // Check and update isFarmSite when process data changes
    if (stepKey === "facilityProcessInformation") {
      checkAndUpdateIsFarmSite(updatedData);
    }
  };
  const handleNext = async () => {
    const currentRef = (activeStep === 0) ? facilityInfoRef :(activeStep===1)?facilityFarmCapacityInfoRef: rawMaterialRef;
    Utills.cl("currentRef", currentRef);
    if (currentRef?.current ) {
      const formik = currentRef.current;
      // submitForm() always increments Formik's submitCount even when validation fails.
      // This is the trigger that makes hasError=true for all invalid fields (red highlight + error text).
      await formik.submitForm();
      const errors = await formik.validateForm();
      if (Object.keys(errors).length === 0) {
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
      } else {
        console.log("[Facility handleNext] Validation errors:", errors);
        notify("Please fill in all required fields before proceeding", "error");
      }
    } else if (activeStep===1){
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    }
  };

  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));
  Utills.cl(facilityData, "data", data);

  const handleFinish = async () => {
    if (facilityData.facilityProcessInformation.length <= 0) {
      notify("Please add atleast one facility process", "error");
      return;
    }
    
    // Only require farm capacity information for MF (Main Facility) or FA (Farm) facility types
    const facilityType = facilityData.facilityInfo.facilityType;
    const requiresFarmCapacity = facilityType === "MF" || facilityType === "FA";
    
    if (requiresFarmCapacity && isFarmSite && facilityData?.facilityFarmCapacityInformation?.length < 1) {
      notify("Please add facility farm capacity information", "error");
      return;
    }

    // B4: Duplicate TE-ID — no two facilities in the same SC may share a TE-ID
    const newTeId = facilityData.facilityInfo.facilityTeId?.trim();
    if (newTeId) {
      const duplicateTeId = tableData.find(
        (item: any) =>
          item.facilityInfo?.facilityTeId?.trim() === newTeId &&
          item.facilityInfo?.facilityId !== facilityId // exclude currently edited row
      );
      if (duplicateTeId) {
        notify(`A facility with TE-ID "${newTeId}" already exists in this Scope Certificate`, "error");
        return;
      }
    }

    // B5: Duplicate facility name — no two facilities in the same SC may share the same name
    const newFacilityName = facilityData.facilityInfo.facilityName?.trim();
    if (newFacilityName) {
      const duplicateName = tableData.find(
        (item: any) =>
          item.facilityInfo?.facilityName?.trim().toLowerCase() === newFacilityName.toLowerCase() &&
          item.facilityInfo?.facilityId !== facilityId // exclude currently edited row
      );
      if (duplicateName) {
        notify(`A facility named "${newFacilityName}" already exists in this Scope Certificate`, "error");
        return;
      }
    }

    if (SC_ID) {
      // Find the existing record in tableData that matches the facilityId
      const existingRecord = tableData.find(
        (item) => item.facilityInfo.facilityId === facilityId
      );
      let payloadFacilityId: string | null = facilityId;
      if (
        existingRecord &&
        existingRecord.facilityInfo.facilityTeId !==
          facilityData?.facilityInfo?.facilityTeId
      ) {
        payloadFacilityId = null;
      }
      const payload = mapToFacilityDetailsReq(facilityData, SC_ID, facilityId);
      // Check if facilityNo exists and has changed
      if (facilityId) {
        // If record exists and facilityNo has changed, handle deletion
        if (
          existingRecord
          &&
          existingRecord.facilityInfo.facilityTeId !==
            payload.facilityTeId
        ) {
          const row = {
            original: {
              facilityInfo: {
                facilityTeId:payload?.facilityTeId,
                // facilityNo: payload.facilityNo,
                facilityId: facilityId,
              },
            },
          };

          onEditDelete(row);
          // The actual save will happen in handleConfirmSave after deletion
          setPendingSave(payload);
          return;
        }

        // If no changes to facility number, save directly
        handleSave(payload);
      } else if (!facilityId) {
        // This is a new facility, not an edit
        handleSave(payload);
      }
    }
  };

  // Compute if Facility Production Capacity is required based on selected process codes
  const isProdCapacityRequiredFor = (processCodes: string[]): boolean => {
    const codeSet = new Set(processCodes || []);
    const farmCodes = FarmCategoryUtils.getFarmCodesSet();
    const supplyChainCodes = FarmCategoryUtils.getSupplyChainCodesSet();
    const exemptComboCodes = FarmCategoryUtils.getExemptComboCodesSet();

    // Only farm codes -> optional
    if ([...codeSet].length > 0 && [...codeSet].every((c) => farmCodes.has(c))) return false;
    // Only supply chain codes -> optional
    if ([...codeSet].length > 0 && [...codeSet].every((c) => supplyChainCodes.has(c))) return false;
    // Only exempt combo codes -> optional
    if ([...codeSet].length > 0 && [...codeSet].every((c) => exemptComboCodes.has(c))) return false;

    const hasFarmCode = [...codeSet].some((c) => farmCodes.has(c));
    const hasNonExemptOtherCode = [...codeSet].some((c) => !farmCodes.has(c) && !exemptComboCodes.has(c));

    // Farm + any other (non-exempt) code -> mandatory
    if (hasFarmCode && hasNonExemptOtherCode) return true;

    // Default -> optional
    return false;
  };

  // Validate conditional rules before POST; notify each failure and block save.
  // currentFacilityId: the ID of the facility currently being edited (from state).
  // This is the authoritative exclusion key — do NOT rely on info?.facilityId which
  // may be empty if the single-facility API maps the field under a different name.
  const validateBeforePost = (state: FacilityState, currentFacilityId?: string): boolean => {
    const info = state?.facilityInfo || ({} as any);
    const processCodes = (state?.facilityProcessInformation || []).map((p) => p?.facilityProcessCategoryCode);
    // Use the passed-in ID first; fall back to whatever the mapped data has
    const excludeId = currentFacilityId || info?.facilityId || "";
    let valid = true;

    // Duplicate TE-ID check — skip if we're editing the facility that owns this TE-ID
    if (info?.facilityTeId) {
      const duplicateTeId = apiData.find((facility: any) =>
        facility?.facilityInfo?.facilityTeId === info.facilityTeId &&
        (excludeId ? facility?.facilityInfo?.facilityId !== excludeId : true)
      );
      if (duplicateTeId) {
        notify(`Facility with TE-ID ${info.facilityTeId} already exists in this SC`, "error");
        valid = false;
      }
    }

    // Duplicate Name check — skip if we're editing the facility that owns this name
    if (info?.facilityName) {
      const duplicateName = apiData.find((facility: any) =>
        facility?.facilityInfo?.facilityName?.trim()?.toLowerCase() === info.facilityName?.trim()?.toLowerCase() &&
        (excludeId ? facility?.facilityInfo?.facilityId !== excludeId : true)
      );
      if (duplicateName) {
        notify(`Facility with Name ${info.facilityName} already exists in this SC`, "error");
        valid = false;
      }
    }

    // Facility Town mandatory
    if (!info?.facilityTown || String(info.facilityTown).trim() === "") {
      notify("Facility Town is required", "error");
      valid = false;
    }

    // Facility Production Capacity is optional — no mandatory check required.

    // CB of Independently Certified Subcontractor for CS
    if (info?.facilityType === "CS") {
      if (!info?.facilityCbOfIndependentlyCertifiedSubcontractor || String(info.facilityCbOfIndependentlyCertifiedSubcontractor).trim() === "") {
        notify("CB of Independently Certified Subcontractor is required", "error");
        valid = false;
      }
    }

    // Facility Last Audit Date required for MF, FA, AS
    if (["MF", "FA", "AS"].includes(info?.facilityType)) {
      if (!info?.facilityLastAuditDate || String(info.facilityLastAuditDate).trim() === "") {
        notify("Facility Last Audit Date is required", "error");
        valid = false;
      }
    }

    // Farm Capacity required for MF/FA with specific process codes
    const farmCapacityRequiredProcessCodes = ['PR0011', 'PR0036', 'PR0037', 'PR0038'];
    if (info?.facilityType === 'MF' || info?.facilityType === 'FA') {
      const requiresFarmCapacity = processCodes.some(code => farmCapacityRequiredProcessCodes.includes(code));
      if (requiresFarmCapacity) {
        if (!state.facilityFarmCapacityInformation || state.facilityFarmCapacityInformation.length === 0) {
          notify("Facility Farm Capacity Information is required for the selected facility type and process codes", "error");
          valid = false;
        }
      }
    }

    // Process Category Code Standard Validations (Rule 6)
    if (scNoOfFarmsFlag && info?.facilityStandard) {
      // Intersect with scStandards to ensure we don't validate against stale standards
      // that were removed from the Scope Certificate but are still saved on the facility.
      const currentStandards = Array.isArray(info.facilityStandard) ? info.facilityStandard : [info.facilityStandard];
      const standards = currentStandards.filter((s: string) => scStandards.includes(s));
      
      // RAF (RWS, RMS, RAS) validation
      if (standards.some((s: string) => ["RWS", "RMS", "RAS"].includes(s))) {
        if (!processCodes.some(code => ["PR0011", "PR0036", "PR0038"].includes(code))) {
          notify("For RAF standards, at least one of PR0011, PR0036, or PR0038 must be selected.", "error");
          valid = false;
        }
      }

      // RDS validation
      if (standards.includes("RDS")) {
        if (!processCodes.some(code => ["PR0011", "PR0037"].includes(code))) {
          notify("For RDS standard, at least one of PR0011 or PR0037 must be selected.", "error");
          valid = false;
        }
      }

      // MMS validation
      if (standards.includes("MMS")) {
        if (processCodes.includes("PR0037")) {
          notify("For MMS standard, PR0037 is not allowed.", "error");
          valid = false;
        }
        if (!processCodes.some(code => ["PR0011", "PR0036", "PR0038"].includes(code))) {
          notify("For MMS standard, at least one of PR0011, PR0036, or PR0038 must be selected.", "error");
          valid = false;
        }
      }
    }

    return valid;
  };

  const handleSave = async (payload: any) => {
    if (!SC_ID) {
      return;
    }
    // Pre-POST validation: block API call if conditional rules not satisfied.
    // Pass facilityId state as currentFacilityId so the exclusion check uses
    // the correct ID regardless of how the single-facility API maps the field.
    if (!validateBeforePost(facilityData, facilityId)) {
      return false;
    }
    let isSuccess = false;
    const queryParams = new URLSearchParams({
      scId: SC_ID,
    }).toString();

    const finalUrl = `${API_ROUTES.CREATE_FACILITY_DETAILS_V4}?${queryParams}`;

    const result: any = await executePost(finalUrl, payload);
    if (result?.status === 200) {
      isSuccess = true;
      notify("Data Saved Successfully", "success");
      
      // Mark this facility as reviewed so it doesn't trigger the "Standards Need Attention" banner 
      // if the user intentionally deselected some standards.
      const teId = facilityData?.facilityInfo?.facilityTeId || payload?.facilityInfo?.facilityTeId || "";
      if (facilityId) useScStore.getState().addReviewedFacility(facilityId);
      if (teId) useScStore.getState().addReviewedFacility(teId);

      // Seed L1 cache immediately from the exact payload sent to the API.
      // The payload already has facilityStandard, facilityProcessInformation, and
      // facilityFarmCapacityInformation — the same fields the violation check reads.
      // This prevents the "Selected Standards: None / Process Codes: None" false warning
      // that would otherwise flash until loadFormData completes its detail API calls.
      const savedFacilityId = payload?.facilityId || facilityId || result?.data?.facilityId || "";
      if (savedFacilityId) {
        setCachedFacilityDetail(savedFacilityId, {
          ...payload,
          facilityStandard: payload?.facilityStandard || facilityData?.facilityInfo?.facilityStandard || [],
          facilityProcessInformation: payload?.facilityProcessInformation || facilityData?.facilityProcessInformation || [],
          facilityFarmCapacityInformation: payload?.facilityFarmCapacityInformation || facilityData?.facilityFarmCapacityInformation || [],
        });
      }

      setFacilityId("");
      setFacilityData(initFacilityState);
      toggleDrawer();
      // Invalidate the saved facility's Zustand cache entry (will be re-fetched fresh).
      invalidateFacilityDetail(facilityId);
      if (teId) invalidateFacilityDetail(teId);
      // Also evict it from localStorage L2 so the prefetch re-fetches it next time.
      if (SC_ID) {
        scCacheService.removeFacilityDetail(SC_ID, facilityId);
        if (teId) scCacheService.removeFacilityDetail(SC_ID, teId);
      }
      // Evict the list cache from both L1 and L2 (facility count / names may have changed).
      clearFacilityListCache();
      if (SC_ID) scCacheService.clearAll(SC_ID); // simplest: nuke all for this SC; prefetch rebuilds
      clearScData();
      incrementFacilityCacheTick(); // Force background prefetch to rebuild caches instantly
      // forceRefresh=true: bypass all L1 caches so the enriched list always reflects the newly saved data.
      loadFormData(true);
      await onNextTab();
    } else {
      notify("Unable to Save", "error");
    }
    return isSuccess;
  };

  const handleConfirmSave = async () => {
    try {
      // If we have a pending save payload, save it now
      let isSaveSuccess: any = false;
      if (pendingSave) {
        delete pendingSave.facilityId;
        isSaveSuccess = await handleSave(pendingSave);
        setPendingSave(null); // Clear the pending save
      }
      if (!pendingSave || isSaveSuccess) {
        await executeDelete(`${API_ROUTES.DELETE_API_V4}`, {
          scId: SC_ID,
          facilityId: facilityId,
          facilityTeId: facilityTeId,
        });

        // Clear facility cache on delete so every remaining facility is re-fetched fresh.
        clearFacilityCache();
        clearFacilityListCache(); // Clear the list cache so the deleted facility is removed
        if (SC_ID) scCacheService.clearAll(SC_ID); // Fix: nuke L2 cache to prevent ghost resurrections
        incrementFacilityCacheTick(); // Force background prefetch to rebuild caches instantly
        await loadFormData();

        // Close the dialog
        setDialogOpen(false);

        // Reset states
        setFacilityId("");
        setFacilityTeId("");
        if (pendingSave) {
          notify("Previous facility successfully deleted", "success");
        } else {
          notify("Successfully deleted", "success");
        }
      }
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };

  const onNext = () => {
    if (
      apiData.filter(
        (facility) => facility?.facilityInfo?.facilityType === "MF"
      ).length == 0
    ) {
      notify("Please add atleast one Main Facility", "error");
    } else {
      navigate(`/v4/sc/${formtype}/product-category-information/${SC_ID}`);
    }
  };

  const handleDeleteSaveData = async () => {
    try {
      if (SC_ID) {
        if (!isDeleteOnly && getDeleteSave()) {
          const userFilledValues = getCurrentFormValues();
          updateTableRowbyIndex(editingIndex, userFilledValues);
        } else if (isDeleteOnly && !getDeleteSave()) {
          removeTableRowbyIndex(editingIndex);
          const deletedData = data.filter((item, index) => {
            index !== editingIndex;
          });
          setData(deletedData);
          setEditingIndex(-1);
        }
        const facilityDetailsData: any = getCurrentTableData();
        setDeleteOnly(false);
        setDeleteSave(false);
        setEditSave(false);
        let isPostCreation = apiData?.length === 1 ? "no" : "yes";
        const facilityDetailsReq = mapToFacilityDetailsReq(
          data,
          SC_ID,
          isPostCreation
        );
        const result: any = await executePost(
          API_ROUTES.CREATE_FACILITY_DETAILS,
          facilityDetailsReq
        );
        if (result?.status === 200) {
          notify("Saved Successfully", "success");
          // toggleDrawer()
          await loadFormData();
        } else {
          notify("Unable to Save", "error");
        }
      }
    } catch (error) {
      console.error("Error saving Facility Details:", error);
      notify("Error saving Facility Details", "error");
    }
  };
  const handleCancelSave = async () => {
    // Utills.cl("inside handleCancelSave", getDeleteSave())
    // if (!isDeleteOnly) {
    //   // toggleDrawer()
    // }
    // if (getEditExistingFacilityDetails.index != -1) {
    //   setEditExistingFacilityDetails({
    //     index: -1, value: ''
    //   })
    //   toggleDrawer()
    // }
    // setDeleteSave(false)
    // await loadFormData()
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };
  const onEdit = (row: any) => {
    const value = row?.original;
    handleOpenFacility(value.facilityInfo.facilityId, value.facilityInfo.facilityTeId, row.index);
  };

  const handleOpenFacility = (fid: string, teId: string, index?: number) => {
    setFacilityId(fid);
    setFacilityTeId(teId);
    if (SC_ID && fid) {
      fetchFacilityDetails(executeNewGet, SC_ID, fid)
        .then((data: any) => {
          const payload = convertFacilityData(data?.data);
          setFacilityData(payload);
          checkAndUpdateIsFarmSite(payload.facilityProcessInformation || []);
          // Increment formKey to force FacilityInfoForm to remount with the new facility's data.
          setFormKey((prev) => prev + 1);
          setDrawerOpen(true);
        })
        .catch((err: any) => notify(err.message, "error"));
    }
    if (index !== undefined) {
      setEditingIndex(index);
    } else {
      // Find index in tableData if not provided
      const idx = tableData.findIndex(item => item.facilityInfo.facilityId === fid);
      setEditingIndex(idx);
    }
    setZustandInitialState(); // Logic inside toggleDrawer reset
  };

  const onDelete = (row: any) => {
    setFacilityId(row?.original?.facilityInfo.facilityId);
    // setFacilityNo(row?.original?.facilityInfo.facilityNo);
    setFacilityTeId(row?.original?.facilityInfo?.facilityTeId);
    setDialogOpen(true);
    setPopUpBtnName("Delete");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(
      `Deleting a Facility will remove all the Associated Records, are you sure want to delete it`
    );
  };

  const onEditDelete = (row: any) => {
    setFacilityId(row?.original?.facilityInfo.facilityId);
    setFacilityTeId(row?.original?.facilityInfo?.facilityTeId);
    // setFacilityNo(row?.original?.facilityInfo.facilityNo);
    setDialogOpen(true);
    setPopUpBtnName("Save");
    setPopUpTitle("Confirm Save ?");
    setPopUpMessage(
      `Editing a Facility No. will remove all the Associated Facility Products, are you sure want to edit it`
    );
  };

  const resetForm = () => {
    setZustandInitialState(initFacilityState);
  };
  const steps = [
    {
      label: "Facility Information",
      content: (
        <FacilityInfoForm
          key={formKey}
          formRef={facilityInfoRef}
          facilityData={facilityData.facilityInfo}
          mainSite={mainFacility}
          mfExists={
            apiData.length > 0 &&
            apiData.filter(
              (facility) => facility?.facilityInfo?.facilityType === "MF"
            ).length > 0
          }
          isEditing={!!facilityId}
          processCodes={facilityData.facilityProcessInformation?.map((process)=>process?.facilityProcessCategoryCode)}
          setFacilityData={(data:any) => handleDataUpdate("facilityInfo", data)}
          setSubsequentFacilityFlag={setSubsequentFacilityFlag}
          subsequentFacilityFlag={subsequentFacilityFlag}
          setScSubsequentFacilityButtonFlag={setScSubsequentFacilityButtonFlag}
          // scNoOfFarmsFlag={scNoOfFarmsFlag}
          // setScNoOfFarmsFlag={setScNoOfFarmsFlag}
          scSubsequentFacilityButtonFlag={scSubsequentFacilityButtonFlag}
          facilityInfoData={facilityData.facilityProcessInformation}
        />
      ),
    },
    {
      label: "Facility Process Information",
      content: (
        <FacilityProcessInfo
          // formRef={rawMaterialRef}
          facilityData={facilityData.facilityInfo}
          facilityProcessInfo={facilityData.facilityProcessInformation}
          facilityFarmCapacityInfo={facilityData.facilityFarmCapacityInformation}
          setFacilityProcessInfo={(data:any) =>
            handleDataUpdate("facilityProcessInformation", data)
          }
          setIsFarmSite={setIsFarmSite}
          isFarmSite={isFarmSite}
          subsequentFacilityFlag={subsequentFacilityFlag}
          setSubsequentFacilityFlag={setSubsequentFacilityFlag}
          scSubsequentFacilityButtonFlag={scSubsequentFacilityButtonFlag}
          setScSubsequentFacilityButtonFlag={setScSubsequentFacilityButtonFlag}
          scNoOfFarmsFlag={scNoOfFarmsFlag}
          setScNoOfFarmsFlag={setScNoOfFarmsFlag}
          scStandards={scStandards}
        />
      ),
    },
    // Show farm capacity step for MF or FA facility type when isFarmSite is true
    ...(isFarmSite && ["MF", "FA"].includes(facilityData?.facilityInfo?.facilityType)) ? [{
      label: "Facility Farm Capacity Information",
      content: (
        <FacilityFarmCapacityInfo
          formRef={facilityFarmCapacityInfoRef}
          facilityData={facilityData.facilityInfo}
          facilityFarmCapacityInfo={facilityData.facilityFarmCapacityInformation}
          facilityStandard={facilityData.facilityInfo?.facilityStandard || []}
          facilityProcessInfo={facilityData.facilityProcessInformation}
          setScSubsequentFacilityButtonFlag={setScSubsequentFacilityButtonFlag}
          setFacilityFarmCapacityInfo={(data:any) =>
            handleDataUpdate("facilityFarmCapacityInformation", data)
          }
        />
      ),
    }] : [],
  ];

  const actions: ActionButtonConfig[] = [
    ...activeStep!==0?[{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as "contained",
      color: "default" as const,
      disabled: activeStep === 0,
    }]:[],
    {
      label: activeStep === steps.length - 1 ? "Save" : "Next",
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained",
      color: "primary",
      disabled: ((activeStep === 1||activeStep === 2) && isRestrictPopUpSave) ||
        (activeStep === 2 && !scSubsequentFacilityButtonFlag),
    },
  ];

  const columns: MRT_ColumnDef<FacilityInformation>[] = [
    // {
    //   accessorKey: "facilityInfo.facilityNo",
    //   header: "Facility No.",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    {
      accessorKey: "facilityInfo.facilityType",
      header: "Facility Type",
      minSize: 60,
      maxSize: 150,
    },
    // {
    //   accessorKey: "facilityInfo.facilityOarId",
    //   header: "OAR ID",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    {
      accessorKey: "facilityInfo.facilityTeId",
      header: "Facility TE-ID",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityName",
      header: "Facility Name",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityPostcode",
      header: "Postcode",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityCountryOrArea",
      header: "Country/Area",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityAddedDate",
      header: "Facility Added Date",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityRemovedDate",
      header: "Facility Removed Date",
      minSize: 60,
      maxSize: 150,
    },
  ];
  console.log(tableData);
  // Per-facility violation check — returns an array of violation objects so the
  // warning banner can show exactly which facility is failing and why.
  // Rules apply only for existing Farm SCs (isFarmSC=Y).
  const getFacilityProcessViolations = (): Array<{facilityName: string; facilityId: string; facilityTeId: string; facilityType: string; standard: string; issue: string}> => {
    if (!scNoOfFarmsFlag) return []; // Not a Farm SC — no farm process rules apply
    if (!tableData || tableData.length === 0) return [];

    const violations: Array<{facilityName: string; facilityId: string; facilityTeId: string; facilityType: string; standard: string; issue: string}> = [];

    for (const facility of tableData) {
      const info = facility?.facilityInfo;
      const facilityName: string = info?.facilityName || "Unknown Facility";
      const facilityId: string = info?.facilityId || "";
      const facilityTeId: string = info?.facilityTeId || facilityId;
      const facilityType: string = info?.facilityType || "";
      const processCodes: string[] = (facility?.facilityProcessInformation ?? []).map(
        (p: any) => p.facilityProcessCategoryCode
      ).filter(Boolean);

      // Skip if processCodes is empty — data is still loading from the detail API.
      // Raising a violation here would be a false positive.
      if (processCodes.length === 0) continue;

      // Determine which standards apply to this facility.
      // Use the facility's own saved facilityStandard intersected with live SC standards.
      // Fall back to all scStandards only if the facility hasn't loaded standards yet.
      const facilityStds: string[] = Array.isArray(info?.facilityStandard)
        ? info.facilityStandard
        : [info?.facilityStandard].filter(Boolean);
      const intersected = facilityStds.filter((s: string) => scStandards.includes(s));
      const standardsToValidate: string[] = intersected.length > 0 ? intersected : scStandards;

      // Rule 5: RAF standards (RWS / RMS / RAS) → at least one of PR0011, PR0036, PR0038
      if (standardsToValidate.some((s: string) => ["RWS", "RMS", "RAS"].includes(s))) {
        if (!processCodes.some((c: string) => ["PR0011", "PR0036", "PR0038"].includes(c))) {
          const failingStd = standardsToValidate.filter((s: string) => ["RWS", "RMS", "RAS"].includes(s)).join(", ");
          violations.push({
            facilityName,
            facilityId,
            facilityTeId,
            facilityType,
            standard: failingStd,
            issue: "At least one of PR0011, PR0036, or PR0038 must be selected.",
          });
        }
      }

      // Rule 6: RDS standard → at least one of PR0011, PR0037
      if (standardsToValidate.includes("RDS")) {
        if (!processCodes.some((c: string) => ["PR0011", "PR0037"].includes(c))) {
          violations.push({
            facilityName,
            facilityId,
            facilityTeId,
            facilityType,
            standard: "RDS",
            issue: "At least one of PR0011 or PR0037 must be selected.",
          });
        }
      }

      // Rule 7: MMS standard → PR0037 forbidden; at least one of PR0011, PR0036, PR0038 required
      if (standardsToValidate.includes("MMS")) {
        if (processCodes.includes("PR0037")) {
          violations.push({
            facilityName,
            facilityId,
            facilityTeId,
            facilityType,
            standard: "MMS",
            issue: "PR0037 is not allowed for MMS.",
          });
        } else if (!processCodes.some((c: string) => ["PR0011", "PR0036", "PR0038"].includes(c))) {
          violations.push({
            facilityName,
            facilityId,
            facilityTeId,
            facilityType,
            standard: "MMS",
            issue: "At least one of PR0011, PR0036, or PR0038 must be selected.",
          });
        }
      }
    }

    return violations;
  };

  const facilityViolations = getFacilityProcessViolations();

  const getFacilityStandardViolations = (): Array<{
    facilityName: string;
    facilityTeId: string;
    facilityId: string;
    facilityType: string;
    missingStandards: string[];
    extraStandards: string[];
    currentStandards: string[];
    processCodes: string[];
  }> => {
    if (!tableData || tableData.length === 0 || scStandards.length === 0) return [];

    const violations: Array<{ 
      facilityName: string; 
      facilityTeId: string; 
      facilityId: string; 
      facilityType: string; 
      missingStandards: string[];
      extraStandards: string[];
      currentStandards: string[];
      processCodes: string[];
    }> = [];

    for (const facility of tableData) {
      const info = facility?.facilityInfo;
      const facilityName: string = info?.facilityName || "Unknown Facility";
      const facilityId: string = info?.facilityId || "";
      const facilityTeId: string = info?.facilityTeId || facilityId;
      const facilityType: string = info?.facilityType || "";

      const rawStd = info?.facilityStandard ?? facility?.facilityStandard;
      
      // Ignore records that haven't loaded standard data yet to prevent flickers
      if (rawStd === undefined || rawStd === null) {
        continue;
      }

      let facilityStds: string[] = [];
      if (Array.isArray(rawStd)) {
        facilityStds = rawStd;
      } else if (typeof rawStd === 'string') {
        facilityStds = rawStd.split(',').map(s => s.trim()).filter(Boolean);
      } else {
        facilityStds = [String(rawStd)].filter(Boolean);
      }
        
      const processCodes: string[] = (facility?.facilityProcessInformation || [])
        .map((p: any) => p.facilityProcessCategoryCode)
        .filter(Boolean);

      // Skip if both standards and process codes are empty — this is a transient
      // loading state on page refresh, not a real violation. Prevents false "Missing: RMS" warnings.
      if (facilityStds.length === 0 && processCodes.length === 0) {
        continue;
      }

      const missing = scStandards.filter((s: string) => !facilityStds.includes(s));
      const extra = facilityStds.filter((s: string) => !scStandards.includes(s));

      // ✅ If standards match perfectly, there is nothing to review.
      if (missing.length === 0 && extra.length === 0) {
        continue;
      }

      // Review Status (Check both UUID and TE-ID)
      const isReviewed = 
        (facilityId && reviewedFacilities.includes(facilityId)) || 
        (facilityTeId && reviewedFacilities.includes(facilityTeId));

      const hasMissingViolation = missing.length > 0 && (facilityType === 'MF' || !isReviewed);
      const hasExtraViolation = extra.length > 0;

      if (hasMissingViolation || hasExtraViolation) {
        violations.push({ 
          facilityName, 
          facilityTeId, 
          facilityId, 
          facilityType, 
          missingStandards: missing,
          extraStandards: extra,
          currentStandards: facilityStds,
          processCodes
        });
      }
    }
    return violations;
  };

  const facilityStandardViolations = getFacilityStandardViolations();

  // Helper for type-based coloring
  const getFacilityTypeColor = (type: string) => {
    switch (type) {
      case 'MF': return { bg: "#ffecb3", border: "#ffb300", text: "#7a4f00" }; // Warm Gold (Important)
      case 'FA': return { bg: "#e1f5fe", border: "#4fc3f7", text: "#01579b" }; // Soft Blue
      case 'CS': return { bg: "#e8f5e9", border: "#81c784", text: "#1b5e20" }; // Soft Green
      case 'AS': return { bg: "#f3e5f5", border: "#ba68c8", text: "#4a148c" }; // Soft Purple
      default: return { bg: "#f5f5f5", border: "#bdbdbd", text: "#424242" };   // Grey
    }
  };

  // Helper for row background color corresponding to facility type chip colors (super soft 97% lightness pastels)
  // Only applies background color if the facility has a warning in the standard or process violations list.
  const getRowBgColor = (row: any) => {
    const facilityId = row.original?.facilityInfo?.facilityId;
    const facilityTeId = row.original?.facilityInfo?.facilityTeId;
    const hasViolation =
      facilityStandardViolations.some((v: any) => v.facilityId === facilityId || v.facilityTeId === facilityTeId) ||
      facilityViolations.some((v: any) => v.facilityId === facilityId || v.facilityTeId === facilityTeId);

    if (!hasViolation) return undefined;

    const type = row.original?.facilityInfo?.facilityType;
    switch (type) {
      case 'MF': return "#FFF8E7"; // Ultra-soft warm gold cream
      case 'FA': return "#E6F8FF"; // Ultra-soft sky ice-blue
      case 'CS': return "#EAFCEE"; // Ultra-soft mint-green
      case 'AS': return "#FAF2FC"; // Ultra-soft lavender-purple
      default: return undefined;
    }
  };

  // Signal to the parent stepper whether this tab has active errors.
  // NO cleanup return — the error flag persists in Zustand even when the user
  // navigates away. This allows MULTIPLE tab pills to be orange simultaneously
  // for a saved SC. The flag is only cleared when this tab re-mounts and
  // the violation count drops to 0 (i.e. the user actually fixed the issue).
  // tabErrors is cleared in full when the parent stepper unmounts (SC_ID change).
  useEffect(() => {
    const hasError = facilityStandardViolations.length > 0 || facilityViolations.length > 0;
    setTabError('facility-details', hasError);
  }, [facilityStandardViolations.length, facilityViolations.length]);

  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          {/* Facility Standards Advisory — shown when one or more facilities may need a standards review */}
          {facilityStandardViolations.length > 0 && (
            <Box mb={1} sx={{ 
              display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1,
              bgcolor: "#fffbf0", 
              border: "1px solid #e8a000", 
              borderRadius: "4px", 
              px: 1.5, py: 0.75 
            }}>
              <Typography variant="caption" sx={{ color: "#7a4f00", fontWeight: 700, mr: 0.5 }}>
                ⚠ Facility Standards Need Attention ({facilityStandardViolations.length}):
              </Typography>
              {facilityStandardViolations.map((v, i) => {
                const colors = getFacilityTypeColor(v.facilityType);
                return (
                  <Tooltip
                    key={i}
                    arrow
                    title={
                      <Box sx={{ p: 0.5 }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, display: "block" }}>
                          {v.facilityName} {v.facilityTeId ? `(TE-ID: ${v.facilityTeId})` : ""}
                        </Typography>
                        <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
                          Type: <strong>{v.facilityType === 'MF' ? 'Main Facility' : v.facilityType}</strong>
                        </Typography>
                        <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
                          Selected Standards: <strong>{v.currentStandards.join(", ") || "None"}</strong>
                        </Typography>
                        <Typography variant="caption" sx={{ display: "block" }}>
                          Process Codes: <strong>{v.processCodes.join(", ") || "None"}</strong>
                        </Typography>
                        {v.missingStandards.length > 0 && (
                          <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
                            Missing: <strong style={{ color: '#ffb300' }}>{v.missingStandards.join(", ")}</strong>
                          </Typography>
                        )}
                        {v.extraStandards.length > 0 && (
                          <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
                            Removed from SC: <strong style={{ color: '#ff5252' }}>{v.extraStandards.join(", ")}</strong>
                          </Typography>
                        )}
                        {v.facilityType !== 'MF' && v.extraStandards.length === 0 && (
                          <Typography variant="caption" sx={{ display: 'block', mt: 1, fontStyle: 'italic', color: '#ffb300' }}>
                            Click 'x' on the chip to acknowledge and dismiss if correct.
                          </Typography>
                        )}
                      </Box>
                    }
                  >
                    <Chip
                      label={`${v.facilityType} - ${v.facilityTeId}`}
                      size="small"
                      onClick={() => handleOpenFacility(v.facilityId, v.facilityTeId)}
                      onDelete={v.facilityType !== 'MF' && v.extraStandards.length === 0 ? () => {
                        const idToReview = v.facilityTeId || v.facilityId;
                        if (idToReview) {
                          useScStore.getState().addReviewedFacility(idToReview);
                        }
                      } : undefined}
                      sx={{
                        bgcolor: colors.bg, color: colors.text, fontWeight: 600,
                        fontSize: "0.7rem", height: 20, cursor: "help",
                        border: `1px solid ${colors.border}`,
                        '& .MuiChip-deleteIcon': {
                          color: colors.text,
                          opacity: 0.7,
                          fontSize: '14px',
                          '&:hover': { opacity: 1 }
                        }
                      }}
                    />
                  </Tooltip>
                );
              })}
              <Typography variant="caption" sx={{ color: "#7a4100", ml: 0.5 }}>
                Hover over each chip for details, or click on the corresponding row below to edit.
              </Typography>
            </Box>
          )}

          {/* Process code violation — compact chip bar */}
          {facilityViolations.length > 0 && (
            <Box mb={1} sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1,
              bgcolor: "#fff8e1", border: "1px solid #f9a825", borderRadius: "4px", px: 1.5, py: 0.75 }}>
              <Typography variant="caption" sx={{ color: "#7a4100", fontWeight: 700, mr: 0.5 }}>
                ⚠ Process Code Issues ({facilityViolations.length}):
              </Typography>
              {facilityViolations.map((v, i) => {
                const colors = getFacilityTypeColor(v.facilityType);
                return (
                  <Tooltip
                    key={i}
                    arrow
                    title={
                      <Box sx={{ p: 0.5 }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, display: 'block' }}>
                          {v.facilityName} {v.facilityTeId ? `· ${v.facilityTeId}` : ""}
                        </Typography>
                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>Standard: <strong>{v.standard}</strong></Typography>
                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>Issue: {v.issue}</Typography>
                      </Box>
                    }
                  >
                    <Chip
                      label={`${v.facilityType} - ${v.facilityTeId}`}
                      size="small"
                      onClick={() => handleOpenFacility(v.facilityId, v.facilityTeId)}
                      sx={{ 
                        bgcolor: colors.bg, color: colors.text, fontWeight: 600,
                        fontSize: "0.7rem", height: 20, cursor: "help",
                        border: `1px solid ${colors.border}`
                      }}
                    />
                  </Tooltip>
                );
              })}
              <Typography variant="caption" sx={{ color: "#7a4100", ml: 0.5 }}>
                Hover over each chip for details, or click on the corresponding row below to edit.
              </Typography>
            </Box>
          )}

          {/* Backend Validation Error Banner */}
          {(() => {
            const errors = useScStore.getState().backendValidationErrors['facility-details'];
            if (!errors || errors.length === 0) return null;
            return (
              <Box mb={2} sx={{
                bgcolor: '#fff4e5',
                border: '1px solid #ff9800',
                borderRadius: '4px',
                padding: '12px 16px',
              }}>
                <Typography variant="body2" sx={{ color: '#b26a00', fontWeight: 700, mb: 0.5 }}>
                  ⚠ Validation Errors Found
                </Typography>
                <ul style={{ margin: 0, paddingLeft: '20px', color: '#7a4100' }}>
                  {errors.map((err, i) => (
                    <li key={i}><Typography variant="body2">{err}</Typography></li>
                  ))}
                </ul>
              </Box>
            );
          })()}
          <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!hasSubmitSC && !scStatus && (
              <StyledButton
                variant="contained"
                onClick={() => {
                  // Always reset to a clean form when adding a new facility.
                  // Previously this only reset when no MF existed, leaving stale
                  // data from the last-edited facility in the form.
                  const hasMF = apiData.filter(
                    (facility) => facility?.facilityInfo?.facilityType === "MF"
                  ).length > 0;
                  setFacilityData({
                    ...initFacilityState,
                    facilityInfo: {
                      ...initFacilityInfo,
                      // Auto-select MF type only when no MF exists yet
                      facilityType: hasMF ? "" : "MF",
                    },
                  });
                  // Force FacilityInfoForm to remount with the clean initial state.
                  setFormKey(prev => prev + 1);
                  toggleDrawer();
                }}
              >
                Add New Facility
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!scStatus}
              getRowBackgroundColor={getRowBgColor}
              renderDetailPanel={({ row }:any) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>No data</>
                )
              }
              renderRowActions={({ row }:any) => (
                <ActionsMenu row={row} onEdit={onEdit} onDelete={onDelete} />
              )}
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title="Add Facility"
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step:any) => setActiveStep(step)}
            />
          </ActionsModalPopup>
          {tableData.length > 0 && !drawerOpen && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap:"0.5rem" }}>
              <NavLink to="/v4/sc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              <InnerButton
                onClick={onNext}
                disabled={facilityViolations.length > 0}
                title={facilityViolations.length > 0 ? "Fix facility process code violations before proceeding" : undefined}
              >Next</InnerButton>
            </Box>
          )}
          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default ScopeCertifiedDetailsComponent;
